import type { LocaleType } from "lib/apollo/types";
import { createRequestContext, getClient } from "lib/apolloClient";
import { NOTIFY_BACK_IN_STOCK } from "./gql";

const storageKey = "PDPEmailNotification";

export const checkOOSStorage = (id: string): boolean => {
  if (typeof localStorage !== "undefined") {
    const list: string[] = JSON.parse(localStorage.getItem(storageKey) || "[]");
    return list.includes(id);
  }
  return false;
};

export const isEmailValid = (email: string): boolean => {
  const isValidEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  if (isValidEmail) return true;
  return false;
};

export const setOOSStorage = (id: string): void => {
  const list = localStorage.getItem(storageKey) || "[]";
  localStorage.setItem(storageKey, JSON.stringify([...JSON.parse(list), id]));
};

export const emailNotification = async (
  email: string,
  variantSku: string,
  locale: LocaleType
): Promise<boolean> => {
  const { data } = await getClient().mutate({
    mutation: NOTIFY_BACK_IN_STOCK,
    variables: {
      email,
      variantSku,
      locale
    },
    context: createRequestContext({ sessionStrategy: "START_NEW_ANONYMOUS" })
  });

  return data.notifyBackInStock;
};
